import { ComponentRoute } from '@/classes'

const SubJobStageRoutes = {
  SubJobStageListView: new ComponentRoute('/subJobStage', 'SubJobStageListView'),
  SubJobStageView: new ComponentRoute('/subJobStage/:subJobStageId', 'SubJobStageView'),
  SubJobStageDetail: new ComponentRoute('/subJobStage/:subJobStageId', 'SubJobStageDetail')
}

export default SubJobStageRoutes
